export const source_map = [
    'M2M',
    'Zillow',
    'Airbnb',
    'VRBO'
]

export const getCopyText : (data: {
    ad?: boolean
    address?: string
    bedroom?: string
    distance?: number
    first_available?: string
    link?: string
    photo?: string
    price?: number
    source?: number
    location?: string
  }, noDom?: boolean) => string = (data, noDom) => {
    let str
    if (!!data.source) {
        str = noDom ? `We found this home for you from ${source_map[data.source]}. It is a ${data.bedroom}B beautifully fully furnished home with flexible lease terms which is only ${data.distance} miles away from ${data.location}. 
        Please use this link below to explore more about this home, currently priced at $${data.price}+/30 days. ${data.link}
        ` : `<p>We found this home for you from ${source_map[data.source]}. It is a ${data.bedroom}B beautifully fully furnished home with flexible lease terms which is only ${data.distance} miles away from ${data.location}.  </p>
        <p>Please use this link below to explore more about this home, currently priced at $${data.price}+/30 days. ${data.link}</p>
        `
    } else {
        str = noDom ? `Thought you might be interested in this Month2Month home located at ${data.location}. It is a ${data.bedroom}B beautifully fully furnished home with flexible lease terms which is only ${data.distance} miles away from ${data.location}. 
        Please use this link below to explore more about this home, currently priced at $${data.price}+/30 days. ${data.link} 
        Some of the benefits of working with Month2month include: 
        Month-to-Month rentals with flexible lease terms 
        Professionally managed homes located throughout Texas, California, Florida, Nevad, South Carolina and Oregon with additional markets coming on daily throughout the United States 
        Everything’s included in your temporary housing including furniture, kitchen housewares, home electronics, utilities, and more 
        ` :
        `<p>Thought you might be interested in this Month2Month home located at ${data.location}. It is a ${data.bedroom}B beautifully fully furnished home with flexible lease terms which is only ${data.distance} miles away from ${data.location}.</p> 
        <p>Please use this link below to explore more about this home, currently priced at $${data.price}+/30 days. ${data.link}</p>
        <p>Some of the benefits of working with Month2month include:</p>
        <ul>
            <li>Month-to-Month rentals with flexible lease terms</li>
            <li>Professionally managed homes located throughout Texas, California, Florida, Nevad, South Carolina and Oregon with additional markets coming on daily throughout the United States</li>
            <li>Everything’s included in your temporary housing including furniture, kitchen housewares, home electronics, utilities, and more</li>
        </ul>`
    }
    return str
}